export function setCrumbs(data) {    
    for (const [key, value] of Object.entries(data)) {
        if(key != 0) {
            if(value.href != "") {
                document.getElementById('breadcrumb-link-' + String(key)).setAttribute('href', String(value.href));
            }
            if(value.text != "") {
                document.getElementById('breadcrumb-link-' + String(key)).innerHTML = String(value.text);
            }
            document.getElementById('breadcrumb-' + String(key)).classList.remove('hidden');
        }
    }

    if(Object.keys(data).length > 0) {
        document.getElementById('breadcrumbs').classList.remove('hidden')
    }
}